var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:danger-triangle-bold-duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65588 5.3805C4.11488 2.7935 4.84488 1.5 5.99988 1.5C7.15538 1.5 7.88488 2.7935 9.34388 5.3805L9.52588 5.703L9.5268 5.70463C10.7387 7.85354 11.3447 8.9282 10.7969 9.714C10.2489 10.5 8.89288 10.5 6.18188 10.5H5.81788C3.10688 10.5 1.75088 10.5 1.20288 9.714C0.655015 8.9282 1.26107 7.85354 2.47296 5.70463L2.47388 5.703L2.65588 5.3805ZM6.39762 3.53975C6.29213 3.43426 6.14905 3.375 5.99987 3.375C5.85068 3.375 5.70761 3.43426 5.60212 3.53975C5.49663 3.64524 5.43736 3.78832 5.43736 3.9375V6.75C5.43736 6.89918 5.49663 7.04226 5.60212 7.14775C5.70761 7.25324 5.85068 7.3125 5.99987 7.3125C6.14905 7.3125 6.29213 7.25324 6.39762 7.14775C6.50311 7.04226 6.56237 6.89918 6.56237 6.75V3.9375C6.56237 3.78832 6.50311 3.64524 6.39762 3.53975ZM6.5302 9.15533C6.38955 9.29598 6.19878 9.375 5.99987 9.375C5.80095 9.375 5.61019 9.29598 5.46953 9.15533C5.32888 9.01468 5.24986 8.82391 5.24986 8.625C5.24986 8.42609 5.32888 8.23532 5.46953 8.09467C5.61019 7.95402 5.80095 7.875 5.99987 7.875C6.19878 7.875 6.38955 7.95402 6.5302 8.09467C6.67086 8.23532 6.74987 8.42609 6.74987 8.625C6.74987 8.82391 6.67086 9.01468 6.5302 9.15533Z",
    fill: "#FFAA00"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.7eb6bdd4225e0da613bcff3e4b5791df.svg";